import { ExclamationCircleOutlined } from '@ant-design/icons'
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import Api from '@api/hotel/ExclusiveOffers'
import DiscountItem from '@components/Hotel/ExclusiveDiscount/DiscountItem'
import { HeaderView } from '@merchant-backend/common-components'
import { isUltimate } from '@merchant-backend/util'
import { getProTitle } from '@util'
import { Button, Flex, Form, message, Modal, Spin } from 'hljd'
import React, { useEffect, useState } from 'react'
import styles from './index.module.less'
import Introduction from './Introduction'

/**
 * 专属优惠
 * @author  Ta_Mu
 * @date  2020/12/11 10:24
 */
const ExclusiveDiscount = () => {
  const [saveLoading, setSaveLoading] = useState(false)

  const [loading, setLoading] = useState(false)

  const [data, setData] = useState({})

  const [editable, setEditable] = useState(false)

  useEffect(() => {
    if (isUltimate()) {
      setEditable(true)
    }
  }, [])

  const onFinish = async values => {
    if (!editable) {
      const title = getProTitle()
      Modal.error({ title: `请开通${title}后使用` })
      return
    }
    setSaveLoading(true)
    const content = values.names || []
    const { success } = await Api.setDiscountInfo(content)
    setSaveLoading(false)
    if (success) {
      message.success('保存成功')
      if (content?.length > 0) {
        setData({ ...data, status: 3 })
      }
      // message.warn('审核中！审核结束后，您将收到我们的通知。')
    }
  }

  const [form] = Form.useForm()

  useEffect(() => {
    getDiscountTagList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDiscountTagList = async () => {
    setLoading(true)
    const { success, data } = await Api.getDiscountList()
    setLoading(false)
    if (success) {
      setData(data)
      form.setFieldsValue({
        names: data.content
      })
    }
  }

  return (
    <HeaderView title="专享优惠">
      {!editable && <Introduction />}
      <Flex sp style={{ paddingBottom: 150 }}>
        <div>
          <span className={styles.title}>
            有吸引力的优惠可以大幅提高用户的联系和成单率
          </span>
          {data?.status === 3 && (
            <p className={styles.reviewStatus}>
              <ExclamationCircleOutlined style={{ marginRight: 6 }} />审核中！审核结束后，您将收到我们的通知。
            </p>
          )}
          {data?.status === 4 && (
            <p className={styles.reviewStatus}>
              未通过审核。原因：{data.reason}
            </p>
          )}
          <Spin spinning={loading}>
            <div className={styles.content}>
              <Form name="dynamic_form_item" onFinish={onFinish} form={form}>
                <Form.List name="names">
                  {(fields, { add, remove }, { errors }) => (
                    <>
                      {fields.map(field => (
                        <DiscountItem
                          key={field.key}
                          field={field}
                          onRemove={() => remove(field.name)}
                        />
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => {
                            if (fields.length >= 3) {
                              message.warn('最多添加3个优惠信息')
                              return
                            }
                            add()
                          }}
                          block
                          icon={<PlusOutlined />}
                          style={{ width: 400, height: 40 }}
                        >
                          添加优惠信息
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                <Form.Item>
                  <div style={{ width: 400, textAlign: 'center' }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={saveLoading}
                      style={{ width: 160 }}
                      size="large"
                    >
                      保存
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </div>
          </Spin>
        </div>
        <div>
          <div style={{ marginLeft: 38, marginBottom: 12 }}>用户端展示:</div>
          <img
            src="https://qnm.hunliji.com/camel-0e7cdc4e-d4df-4209-bbc8-8a3d5e557ae3.png"
            alt="用户端展示"
            width="356"
          />
        </div>
      </Flex>
    </HeaderView>
  )
}

export default ExclusiveDiscount
